export default __webpack_public_path__ + "static/media/misc-books1-1024w.3b11f073.png";